import { t } from "i18next";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";
import type { AnyObject, Flags, Maybe, Message } from "yup";

/*
 * Custom validators
 */

Yup.addMethod(Yup.string, "phone", function (errorMessage: Message) {
  return this.test(`test-phone`, errorMessage, function (value) {
    const { path, createError } = this;

    const phoneNumber = value || "";

    if (phoneNumber === "") return true;

    return (
      isPossiblePhoneNumber(phoneNumber) ||
      createError({ path, message: errorMessage })
    );
  });
});

/*
 * Types declaration for validators
 */

declare module "yup" {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext = AnyObject,
    TDefault = undefined,
    TFlags extends Flags = ""
  > {
    phone(
      errorMessage: Message
    ): StringSchema<TType, TContext, TDefault, TFlags>;
  }
}

/*
 * Validators
 */

export const EmailValidator = Yup.string().email(t("VALIDATION.EMAIL"));
export const PhoneValidator = Yup.string().phone(t("VALIDATION.PHONE"));
export const LoginPasswordValidator = Yup.string()
  .min(8, "VALIDATION.PASSWORD.SHORT")
  .max(128, "VALIDATION.PASSWORD.LONG");

export const PasswordValidator = Yup.string()
  .min(8, "VALIDATION.PASSWORD.SHORT")
  .max(128, "VALIDATION.PASSWORD.LONG")
  .matches(/^(?=.*[!@#$%^&*])/, "VALIDATION.PASSWORD.SPECIAL");
